// ============================================================
// WANKUL LOYALTY - v5.8 — CARTE + GYROSCOPE (fix taille)
// ===========================================================

(function () {
  'use strict';

  var TIERS = [
    { min: 0,    max: 400,   label: '0 – 400' },
    { min: 500,  max: 1000,  label: '500 – 1000' },
    { min: 1500, max: 2000,  label: '1500 – 2000' },
    { min: 2001, max: 99999, label: '2000 +' },
  ];

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function getCardPoints(card) {
    var text = card.innerText || card.textContent || '';
    var match = text.match(/(\d[\d\s,]*)\s*(WC|wc|Wankulcoin)/i);
    if (match) return parseInt(match[1].replace(/[\s,]/g, ''), 10);
    var lines = text.trim().split('\n');
    for (var i = 0; i < lines.length; i++) {
      var line = lines[i].trim();
      var num = parseInt(line.replace(/[\s,]/g, ''), 10);
      if (!isNaN(num) && num > 0 && num < 100000) return num;
    }
    return null;
  }

  function injectReferralBadge() {
    var titleEl = document.querySelector('.appstleLoyaltyPageV2ReferralSectionHeader .appstleLoyaltyPageV2SectionHeaderTitle');
    if (!titleEl || titleEl.dataset.tampon) return false;
    titleEl.dataset.tampon = '1';
    var wrap = document.createElement('div');
    wrap.className = 'wk-referral-title-wrap';
    titleEl.parentNode.insertBefore(wrap, titleEl);
    wrap.appendChild(titleEl);
    var tampon = document.createElement('div');
    tampon.className = 'wk-tampon';
    tampon.innerHTML = '<div class="wk-tampon-inner"><span class="wk-tampon-text">Nouveau</span></div>';
    wrap.appendChild(tampon);
    return true;
  }

  function toggleHowItWorks() {
    var section = document.querySelector('.appstleLoyaltyPageV2HowItWorks');
    if (!section) return false;
    var isLoggedIn = !!document.getElementById('wk-loyalty-card');
    section.style.display = isLoggedIn ? 'none' : '';
    return true;
  }

  function injectEarnArrows() {
    var list = document.querySelector('.appstleLoyaltyPageV2WaysToEarnList');
    if (!list || list.dataset.arrows) return false;
    var section = list.closest('[class*="EarnRewards"]') || list.parentNode;
    var header = section ? (section.querySelector('[class*="SectionHeader"]') || section.querySelector('[class*="Header"]')) : null;
    if (!header) return false;
    list.dataset.arrows = '1';
    list.style.scrollBehavior = 'smooth';
    var arrows = document.createElement('div');
    arrows.className = 'wk-carousel-arrows wk-earn-arrows';
    arrows.innerHTML = [
      '<button class="wk-arrow wk-arrow-prev" aria-label="Précédent">',
      '<svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M10 3L5 8L10 13" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
      '</button>',
      '<button class="wk-arrow wk-arrow-next" aria-label="Suivant">',
      '<svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M6 3L11 8L6 13" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
      '</button>',
    ].join('');
    header.style.position = 'relative';
    header.appendChild(arrows);
    var SCROLL_AMOUNT = 320;
    arrows.querySelector('.wk-arrow-prev').addEventListener('click', function () {
      list.scrollBy({ left: -SCROLL_AMOUNT, behavior: 'smooth' });
    });
    arrows.querySelector('.wk-arrow-next').addEventListener('click', function () {
      list.scrollBy({ left: SCROLL_AMOUNT, behavior: 'smooth' });
    });
    function updateArrows() {
      var prev = arrows.querySelector('.wk-arrow-prev');
      var next = arrows.querySelector('.wk-arrow-next');
      prev.classList.toggle('wk-arrow-disabled', list.scrollLeft <= 0);
      next.classList.toggle('wk-arrow-disabled', list.scrollLeft + list.clientWidth >= list.scrollWidth - 2);
    }
    list.addEventListener('scroll', updateArrows);
    setTimeout(updateArrows, 300);
    return true;
  }

  function organizeTiers() {
    var list = document.querySelector('.appstleLoyaltyPageV2WaysToRedeemList');
    if (!list || list.dataset.tiered) return false;
    var cards = Array.from(list.querySelectorAll(':scope > *'));
    if (cards.length === 0) return false;
    var canRead = cards.some(function (c) { return getCardPoints(c) !== null; });
    if (!canRead) return false;
    list.dataset.tiered = '1';
    var groups = {};
    TIERS.forEach(function (t) { groups[t.label] = []; });
    cards.forEach(function (card) {
      var pts = getCardPoints(card);
      if (pts === null) return;
      var tier = TIERS.find(function (t) { return pts >= t.min && pts <= t.max; });
      if (tier) groups[tier.label].push(card);
    });
    var hasCards = TIERS.some(function (t) { return groups[t.label].length > 0; });
    if (!hasCards) return false;
    if (!document.getElementById('wk-tiers-style')) {
      var style = document.createElement('style');
      style.id = 'wk-tiers-style';
      style.textContent = [
        '.wk-tiers-wrap { position: relative; z-index: 1; }',
        '.wk-tier-block { margin-bottom: 40px; }',
        '.wk-tier-header { display: flex; align-items: center; gap: 12px; padding: 16px 24px 12px; border-bottom: 1px solid rgba(0,0,0,0.08); margin-bottom: 4px; }',
        '.wk-tier-range { font-size: 1rem; font-weight: 800; letter-spacing: 1px; background: linear-gradient(135deg, #FF8C00, #FFD700); color: #000000; padding: 6px 18px; border-radius: 999px; display: inline-block; }',
        '.wk-tier-carousel { display: flex !important; flex-direction: row !important; flex-wrap: nowrap !important; overflow-x: auto !important; overflow-y: hidden !important; scrollbar-width: none !important; -ms-overflow-style: none !important; gap: 12px !important; padding: 16px 24px 28px !important; align-items: stretch !important; scroll-behavior: smooth !important; }',
        '.wk-tier-carousel::-webkit-scrollbar { display: none !important; }',
      ].join('\n');
      document.head.appendChild(style);
    }
    var wrap = document.createElement('div');
    wrap.className = 'wk-tiers-wrap';
    var holoClasses = ['wk-holo-a', 'wk-holo-ab', 'wk-holo-b', 'wk-holo-c'];
    TIERS.forEach(function (tier, index) {
      var tierCards = groups[tier.label];
      if (tierCards.length === 0) return;
      var block = document.createElement('div');
      block.className = 'wk-tier-block';
      var header = document.createElement('div');
      header.className = 'wk-tier-header';
      header.innerHTML = '<span class="wk-tier-range">' + tier.label + '</span>';
      var arrows = document.createElement('div');
      arrows.className = 'wk-carousel-arrows';
      arrows.innerHTML = [
        '<button class="wk-arrow wk-arrow-prev" aria-label="Précédent">',
        '<svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M10 3L5 8L10 13" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
        '</button>',
        '<button class="wk-arrow wk-arrow-next" aria-label="Suivant">',
        '<svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M6 3L11 8L6 13" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
        '</button>',
      ].join('');
      header.appendChild(arrows);
      block.appendChild(header);
      var carousel = document.createElement('div');
      carousel.className = 'wk-tier-carousel';
      var holoClass = holoClasses[index];
      tierCards.forEach(function (card) {
        card.classList.add(holoClass);
        carousel.appendChild(card);
      });
      block.appendChild(carousel);
      wrap.appendChild(block);
      var SCROLL_AMOUNT = 300;
      arrows.querySelector('.wk-arrow-prev').addEventListener('click', function () {
        carousel.scrollBy({ left: -SCROLL_AMOUNT, behavior: 'smooth' });
      });
      arrows.querySelector('.wk-arrow-next').addEventListener('click', function () {
        carousel.scrollBy({ left: SCROLL_AMOUNT, behavior: 'smooth' });
      });
      function updateArrows() {
        var prev = arrows.querySelector('.wk-arrow-prev');
        var next = arrows.querySelector('.wk-arrow-next');
        prev.classList.toggle('wk-arrow-disabled', carousel.scrollLeft <= 0);
        next.classList.toggle('wk-arrow-disabled', carousel.scrollLeft + carousel.clientWidth >= carousel.scrollWidth - 2);
      }
      carousel.addEventListener('scroll', updateArrows);
      setTimeout(updateArrows, 200);
    });
    list.parentNode.insertBefore(wrap, list);
    list.parentNode.removeChild(list);
    return true;
  }

  function getAvailableWC() {
    var coinsEl = document.querySelector('.wk-coins-value');
    if (coinsEl) {
      var val = parseInt((coinsEl.textContent || '').replace(/\s/g, ''), 10);
      if (!isNaN(val)) return val;
    }
    var heroVals = document.querySelectorAll('.appstleLoyaltyPageV2HeroCardValue');
    if (heroVals.length > 0) {
      var val2 = parseInt((heroVals[0].textContent || '').replace(/\s/g, ''), 10);
      if (!isNaN(val2)) return val2;
    }
    return null;
  }

  function applyAffordability() {
    var available = getAvailableWC();
    if (available === null) {
      document.querySelectorAll('.wk-locked').forEach(function (card) {
        card.classList.remove('wk-locked');
        var badge = card.querySelector('.wk-locked-badge');
        if (badge) badge.remove();
      });
      return;
    }
    document.querySelectorAll('.wk-tier-carousel .appstleLoyaltyPageV2WaysToRedeemListItem').forEach(function (card) {
      var descEl = card.querySelector('.appstleLoyaltyPageV2WaysToRedeemListItemDescription');
      if (!descEl) return;
      var text = descEl.innerText || descEl.textContent || '';
      var match = text.match(/(\d[\d\s,]*)/);
      if (!match) return;
      var price = parseInt(match[1].replace(/[\s,]/g, ''), 10);
      if (isNaN(price)) return;
      if (price > available) {
        card.classList.add('wk-locked');
        if (!card.querySelector('.wk-locked-badge')) {
          var badge = document.createElement('div');
          badge.className = 'wk-locked-badge';
          badge.textContent = 'Il vous manque ' + (price - available).toLocaleString('fr-FR') + ' WC';
          card.appendChild(badge);
        }
      } else {
        card.classList.remove('wk-locked');
        var existing = card.querySelector('.wk-locked-badge');
        if (existing) existing.remove();
      }
    });
  }

  function getInner(card) { return card; }

  function injectHoloOverlay(card) {
    if (card.dataset.holoOverlay) return;
    card.dataset.holoOverlay = '1';
    var inner = getInner(card);
    inner.style.position = 'relative';
    var overlay = document.createElement('div');
    overlay.className = 'wk-holo-overlay';
    inner.appendChild(overlay);
  }

  function injectGoldOverlays(card) {
    if (card.dataset.goldOverlay) return;
    card.dataset.goldOverlay = '1';
    var inner = getInner(card);
    inner.style.position = 'relative';
    var sweep = document.createElement('div');
    sweep.className = 'wk-gold-overlay';
    inner.appendChild(sweep);
    for (var i = 0; i < 16; i++) {
      var s = document.createElement('div');
      s.className = 'wk-spark';
      var sx = (Math.random() * 20 - 10).toFixed(0) + 'px';
      s.style.cssText = [
        '--dur:'   + (1.6 + Math.random() * 2.2).toFixed(1) + 's',
        '--delay:' + (Math.random() * 3.5).toFixed(1) + 's',
        '--sx:'    + sx,
        'left:'    + Math.round(Math.random() * 85 + 5) + '%',
        'bottom:8px',
      ].join(';');
      inner.appendChild(s);
    }
  }

  function initHoloEffect() {
    function scanCards() {
      document.querySelectorAll('.wk-holo-a, .wk-holo-ab, .wk-holo-b, .wk-holo-c').forEach(function (card) {
        injectHoloOverlay(card);
      });
      document.querySelectorAll('.wk-holo-c').forEach(function (card) {
        injectGoldOverlays(card);
      });
    }
    scanCards();
    setTimeout(scanCards, 1000);
    setTimeout(scanCards, 2500);
  }

  function extractFirstName(selector) {
    var el = document.querySelector(selector);
    if (!el) return null;
    var text = (el.innerText || el.textContent || '').trim();
    return text.replace(/bonjour[,\s]*/i, '').replace(/[!,]/g, '').trim() || text;
  }

  function extractCoins() {
    var els = document.querySelectorAll('.appstleLoyaltyPageV2HeroCardValue');
    var coins = null, rang = null;
    els.forEach(function (el, i) {
      var t = (el.innerText || el.textContent || '').trim();
      if (i === 0) coins = t;
      if (i === 1) rang  = t;
    });
    return { coins: coins, rang: rang };
  }

  function injectLoyaltyCard() {
    if (document.getElementById('wk-loyalty-card')) return false;
    var hero = document.querySelector('.appstleLoyaltyPageV2HeroContainer');
    if (!hero) return false;

    var firstName = extractFirstName('.appstleLoyaltyPageV2HeroCustomerHeading');
    var data      = extractCoins();
    if (!firstName && !data.coins) return false;

    var displayName  = firstName  || '—';
    var displayCoins = data.coins || '—';
    var displayRang  = data.rang  || '';

    if (!document.getElementById('wk-card-style')) {
      var style = document.createElement('style');
      style.id  = 'wk-card-style';
      style.textContent = [
        /* Wrap — centré, couvre tout le hero */
        '.wk-card-wrap { display:flex !important; justify-content:center !important; align-items:center !important; flex-direction:column !important; gap:12px !important; padding:40px 24px !important; width:100% !important; box-sizing:border-box !important; position:absolute !important; top:0 !important; left:0 !important; right:0 !important; bottom:0 !important; z-index:10 !important; pointer-events:none !important; }',

        /* Carte — taille fixe desktop, le plugin ne peut pas l'écraser car on utilise un conteneur intermédiaire */
        '.wk-card-outer { width:520px; max-width:calc(100vw - 48px); flex-shrink:0; pointer-events:auto !important; }',

        '.wk-loyalty-card { width:100% !important; height:300px; border-radius:18px; position:relative; overflow:hidden; cursor:pointer;',
        '  background:#111111;',
        '  box-shadow:0 0 0 1px rgba(212,175,55,0.12), 0 24px 64px rgba(0,0,0,0.9);',
        '  transition:transform 0.15s ease, box-shadow 0.3s ease; }',
        '.wk-loyalty-card:hover { box-shadow:0 0 0 1px rgba(212,175,55,0.22), 0 32px 80px rgba(0,0,0,0.95); }',

        '.wk-brushed { position:absolute; inset:0; z-index:1; background:repeating-linear-gradient(90deg, transparent 0px, transparent 2px, rgba(255,255,255,0.012) 2px, rgba(255,255,255,0.012) 3px); }',
        '.wk-sheen { position:absolute; inset:0; z-index:2; background:linear-gradient(125deg, rgba(255,255,255,0.06) 0%, transparent 35%, rgba(255,255,255,0.02) 55%, transparent 75%, rgba(255,255,255,0.04) 100%); animation:wk-sheen-anim 8s ease-in-out infinite; }',
        '@keyframes wk-sheen-anim { 0%,100%{opacity:1} 50%{opacity:0.6} }',
        '.wk-gold-tl { position:absolute; top:0; left:0; width:150px; height:150px; z-index:3; background:radial-gradient(ellipse at 0% 0%, rgba(212,175,55,0.12) 0%, transparent 70%); }',
        '.wk-gold-br { position:absolute; bottom:0; right:0; width:180px; height:120px; z-index:3; background:radial-gradient(ellipse at 100% 100%, rgba(212,175,55,0.08) 0%, transparent 70%); }',
        '.wk-gold-line-top { position:absolute; top:0; left:10%; right:10%; height:1px; z-index:4; background:linear-gradient(90deg, transparent, rgba(212,175,55,0.5), rgba(245,224,106,0.8), rgba(212,175,55,0.5), transparent); }',
        '.wk-gold-line-bottom { position:absolute; bottom:0; left:20%; right:20%; height:1px; z-index:4; background:linear-gradient(90deg, transparent, rgba(212,175,55,0.3), rgba(212,175,55,0.3), transparent); }',
        '.wk-chip { position:absolute; top:22px; right:28px; width:38px; height:30px; border-radius:6px; z-index:5; background:linear-gradient(135deg,#8B6914 0%,#D4AF37 35%,#F5E06A 55%,#C9971F 80%,#8B6914 100%); box-shadow:0 2px 8px rgba(0,0,0,0.5), inset 0 1px 0 rgba(255,255,255,0.2); }',
        '.wk-chip::before { content:""; position:absolute; inset:5px; border-radius:2px; border:1px solid rgba(0,0,0,0.2); }',
        '.wk-chip::after { content:""; position:absolute; left:50%; top:0; bottom:0; width:1px; background:rgba(0,0,0,0.18); transform:translateX(-50%); }',
        '.wk-card-hover { position:absolute; inset:0; z-index:4; opacity:0; transition:opacity 0.2s; pointer-events:none; }',
        '.wk-loyalty-card:hover .wk-card-hover { opacity:1; }',
        '.wk-card-body { position:absolute; inset:0; z-index:6; padding:20px 26px; }',
        '.wk-card-top-left { position:absolute; top:20px; left:26px; display:flex; flex-direction:column; gap:2px; }',
        '.wk-card-hello { font-size:9px; font-weight:500; color:rgba(212,175,55,0.5); letter-spacing:3px; text-transform:uppercase; }',
        '.wk-card-name { font-size:28px; font-weight:700; color:rgba(255,255,255,0.92); letter-spacing:-1px; line-height:1; }',
        '.wk-card-center { position:absolute; top:50%; left:50%; transform:translate(-50%,-50%); display:flex; flex-direction:column; align-items:center; gap:8px; }',
        '.wk-coins-label { font-size:9px; font-weight:500; color:rgba(255,255,255,0.25); letter-spacing:2px; text-transform:uppercase; }',
        '.wk-coins-value { font-size:52px; font-weight:700; color:rgba(255,255,255,0.92); letter-spacing:-2px; line-height:1; }',
        '.wk-card-rank { display:inline-flex; align-items:center; gap:5px; background:rgba(212,175,55,0.08); border:1px solid rgba(212,175,55,0.22); border-radius:999px; padding:3px 12px; }',
        '.wk-rank-dot { width:5px; height:5px; border-radius:50%; background:#D4AF37; animation:wk-blink 2.5s ease-in-out infinite; }',
        '@keyframes wk-blink { 0%,100%{opacity:1} 50%{opacity:0.3} }',
        '.wk-rank-text { font-size:9px; font-weight:600; color:rgba(212,175,55,0.75); letter-spacing:1.5px; text-transform:uppercase; }',
        '.wk-card-watermark { position:absolute; bottom:14px; right:28px; z-index:6; font-size:8px; font-weight:700; color:rgba(212,175,55,0.1); letter-spacing:4px; text-transform:uppercase; }',

        /* Bouton gyroscope iOS */
        '.wk-gyro-btn { display:inline-flex; align-items:center; gap:6px; background:rgba(212,175,55,0.08); border:1px solid rgba(212,175,55,0.3); border-radius:999px; padding:6px 16px; cursor:pointer; color:rgba(212,175,55,0.8); font-size:11px; font-weight:600; letter-spacing:1px; transition:background 0.2s; pointer-events:auto !important; }',
        '.wk-gyro-btn:hover { background:rgba(212,175,55,0.15); }',
        '.wk-gyro-btn.wk-gyro-active { display:none !important; }',

        /* Mobile */
        '@media (max-width:599px) {',
        '  .wk-card-outer { width:100%; max-width:100%; }',
        '  .wk-loyalty-card { height:200px !important; border-radius:12px !important; }',
        '  .wk-coins-value { font-size:36px !important; }',
        '  .wk-card-name { font-size:20px !important; }',
        '  .wk-card-wrap { padding:16px !important; }',
        '  .wk-chip { top:14px; right:16px; width:30px; height:24px; }',
        '}',
      ].join('\n');
      document.head.appendChild(style);
    }

    var wrap = document.createElement('div');
    wrap.className = 'wk-card-wrap';

    /* Conteneur intermédiaire — style inline, le plugin ne peut pas l'écraser */
    var outer = document.createElement('div');
outer.className = 'wk-card-outer';
outer.style.cssText = 'width:520px !important;max-width:calc(100vw - 32px) !important;flex-shrink:0 !important;pointer-events:auto !important;box-sizing:border-box !important;';    var card = document.createElement('div');
    card.className = 'wk-loyalty-card';
    card.id = 'wk-loyalty-card';

    var rankHtml = displayRang
      ? '<div class="wk-card-rank"><div class="wk-rank-dot"></div><div class="wk-rank-text">' + displayRang + '</div></div>'
      : '';

    card.innerHTML = [
      '<div class="wk-brushed"></div>',
      '<div class="wk-sheen"></div>',
      '<div class="wk-gold-tl"></div>',
      '<div class="wk-gold-br"></div>',
      '<div class="wk-gold-line-top"></div>',
      '<div class="wk-gold-line-bottom"></div>',
      '<img src="https://cdn.shopify.com/s/files/1/0683/2055/9412/files/Laink_et_terracid_doree.png?v=1778840390" class="wk-chip-logo" alt="Wankul">',
      '<div class="wk-card-hover" id="wk-card-hover"></div>',
      '<div class="wk-card-body">',
      '  <div class="wk-card-top-left">',
      '    <div class="wk-card-hello">Bonjour</div>',
      '    <div class="wk-card-name">' + displayName + '</div>',
      '  </div>',
      '  <div class="wk-card-center">',
      '    <div class="wk-coins-label">Wankulcoins</div>',
      '    <div class="wk-coins-value">' + displayCoins + '</div>',
      rankHtml,
      '  </div>',
      '</div>',
      '<div class="wk-card-watermark">Wankul</div>',
    ].join('');

    outer.appendChild(card);
    wrap.appendChild(outer);

    /* Bouton gyroscope iOS */
    var gyroBtn = null;
    var isIOS = /iPhone|iPad|iPod/.test(navigator.userAgent);
    var isMobile = /Mobi|Android/i.test(navigator.userAgent) || isIOS;

    if (isMobile && isIOS && typeof DeviceOrientationEvent !== 'undefined' && typeof DeviceOrientationEvent.requestPermission === 'function') {
      gyroBtn = document.createElement('button');
      gyroBtn.className = 'wk-gyro-btn';
      gyroBtn.innerHTML = '✦ Activer l\'effet gyroscope';
      wrap.appendChild(gyroBtn);
    }

    /* Sur mobile, outer prend toute la largeur */
   

    hero.parentNode.insertBefore(wrap, hero);

    var hov = document.getElementById('wk-card-hover');

    /* Hover souris desktop */
    card.addEventListener('mousemove', function (e) {
      var r = card.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width;
      var y = (e.clientY - r.top)  / r.height;
      card.style.transform = 'perspective(1000px) rotateX(' + ((y-0.5)*-6) + 'deg) rotateY(' + ((x-0.5)*6) + 'deg) translateY(-5px)';
      hov.style.background = 'radial-gradient(ellipse 60% 50% at ' + (x*100) + '% ' + (y*100) + '%, rgba(212,175,55,0.07) 0%, transparent 65%)';
    });
    card.addEventListener('mouseleave', function () {
      card.style.transform = '';
      hov.style.background = '';
    });

    /* Gyroscope Android */
    if (isMobile && !isIOS && typeof DeviceOrientationEvent !== 'undefined') {
      startGyroscope();
    }

    /* Gyroscope iOS */
    if (gyroBtn) {
      gyroBtn.addEventListener('click', function () {
        DeviceOrientationEvent.requestPermission().then(function (state) {
          if (state === 'granted') {
            gyroBtn.classList.add('wk-gyro-active');
            startGyroscope();
          }
        }).catch(function () {});
      });
    }

    function startGyroscope() {
      var baseGamma = null;
      var baseBeta  = null;
      window.addEventListener('deviceorientation', function (e) {
        var gamma = e.gamma || 0;
        var beta  = e.beta  || 0;
        if (baseGamma === null) { baseGamma = gamma; baseBeta = beta; return; }
        var tiltY = Math.max(-20, Math.min(20, (gamma - baseGamma) * 1.2));
        var tiltX = Math.max(-20, Math.min(20, (beta  - baseBeta)  * 0.8));
        var px = ((tiltY / 20) * 0.5 + 0.5) * 100;
        var py = ((tiltX / 20) * 0.5 + 0.5) * 100;
        card.style.transform = 'perspective(1000px) rotateX(' + (-tiltX) + 'deg) rotateY(' + tiltY + 'deg)';
        hov.style.background = 'radial-gradient(ellipse 60% 50% at ' + px + '% ' + py + '%, rgba(212,175,55,0.07) 0%, transparent 65%)';
      });
    }

    return true;
  }

  var tiersApplied = false;
  var cardInjected = false;
  var earnDone     = false;
  var badgeDone    = false;
  var attempts     = 0;

  function init() {
    attempts++;
    if (!cardInjected) cardInjected = injectLoyaltyCard();
    if (cardInjected)  toggleHowItWorks();
    if (!tiersApplied) tiersApplied = organizeTiers();
    if (!earnDone)     earnDone     = injectEarnArrows();
    if (!badgeDone)    badgeDone    = injectReferralBadge();
    if (tiersApplied && cardInjected) setTimeout(applyAffordability, 300);
    if (tiersApplied && cardInjected && earnDone && badgeDone) return;
    if (attempts >= 40) return;
    setTimeout(init, 250);
  }

  ready(function () {
    setTimeout(init, 300);
    setTimeout(initHoloEffect, 900);
  });

})();